import Vue from 'vue'

export default function () {
	Vue.component('vendor-craftsmen-submit-dialog', () => import('./VendorCraftsmenSubmitDialog'))
	Vue.component('vendor-craftsman-archive-dialog', () => import('./VendorCraftsmanArchiveDialog'))
}
